var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.314,
    height: 17.314,
    viewBox: "0 0 17.314 17.314",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #002e6b;\r\n        stroke-linecap: round;\r\n        stroke-width: 2px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19885",
    "data-name": "Group 19885",
    transform: "translate(9820.717 23910.854)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18576",
    "data-name": "Group 18576",
    transform: "translate(-9810.102 -23914.725) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7511",
    "data-name": "Path 7511",
    className: "cls-1",
    d: "M-17240.611-5493.958v20.487",
    transform: "translate(17248.086 5493.958)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18929",
    "data-name": "Group 18929",
    transform: "translate(-9799.531 -23900.238) rotate(135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7511-2",
    "data-name": "Path 7511",
    className: "cls-1",
    d: "M-17240.611-5493.958v20.487",
    transform: "translate(17248.086 5493.958)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.73d6e54ac65a953b751f0554008a0295.svg";
export { ForwardRef as ReactComponent };